import { useEffect, useState } from "react";
import { v4, v5 } from "uuid";

interface UserBrowserInfo {
  browser: string;
  location: string;
  referrer: string;
  screen_height: number;
  screen_width: number;
}

/**
 * React hook to generate a unique user ID based on the user's browser information.
 * Falls back to a random UUID if browser APIs are not available or if an error occurs during generation.
 */
export function useUniqueUserId(): string {
  const [userId, setUserId] = useState<string>(() => v4());

  useEffect(() => {
    try {
      const userInfo: UserBrowserInfo = {
        browser: navigator.userAgent,
        location: document.location.origin,
        referrer: document.referrer,
        screen_height: screen.height,
        screen_width: screen.width,
      };

      const userInfoString = Object.values(userInfo).join("|");
      const clientSpecificId = v5(userInfoString, v5.URL);

      // Set the client ID to a unique value based on the user's browser information
      // This will be consistent across sessions for the same user
      setUserId(clientSpecificId);
    } catch (error) {
      console.error("Error generating client-specific unique user ID; will use initial random UUID:", error);
    }
  }, []);

  return userId;
}
